import { UPDATE_ACCESS } from '../actions/access';
import { LOGOUT } from '../actions/screen';

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ACCESS: {
            return Object.assign({}, state, action.data);
        }
        case LOGOUT:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
